module.exports = __webpack_public_path__ + "static/media/arrowUp.11a81dba.svg";